import { lazy } from "react";
import { Navigate, Route } from "react-router-dom";
import { DashboardRoute, AuthRoute, VerifyWrapper } from "./helpers";
import { RouteStore, TabNames } from "./type";
import LandingPageLocationWrapper from "../components/Popup/LandingPageLocation";
import { SchoolStatePageWrapper, TeacherStatePageWrapper } from "../pages/TeacherPage/locationBasedPages/StatePageWrapper";

const HomePage = lazy(() =>
  import("../pages/HomePage").then((module) => ({
    default: module.default,
  }))
);

const Dashboard = lazy(() =>
  import("../pages/Dashboard").then((module) => ({
    default: module.default,
  }))
)

const TeacherPage = lazy(() =>
  import("../pages/TeacherPage").then((module) => ({
    default: module.default,
  }))
);
const VicTeacherPage = lazy(() =>
  import("../pages/TeacherPage/locationBasedPages/VicTeacherPage").then((module) => ({
    default: module.default,
  }))
);
const NswTeacherPage = lazy(() =>
  import("../pages/TeacherPage/locationBasedPages/NswTeacherPage").then((module) => ({
    default: module.default,
  }))
);
const SchoolPage = lazy(() =>
  import("../pages/SchoolPage").then((module) => ({
    default: module.default,
  }))
);
const VicSchoolPage = lazy(() =>
  import("../pages/SchoolPage/locationBasedPages/VicSchoolPage").then((module) => ({
    default: module.default,
  }))
);
const NswSchoolPage = lazy(() =>
  import("../pages/SchoolPage/locationBasedPages/NswSchoolPage").then((module) => ({
    default: module.default,
  }))
);

// const ECCPage = lazy(() => 
//   import("../pages/ECCPage").then((module) => ({
//     default: module.default,
//   }))
// )
const ECCCentrePage = lazy(() => 
  import("../pages/ECCPage/centre").then((module) => ({
    default: module.default,
  }))
)
const ECCEducatorPage = lazy(() => 
  import("../pages/ECCPage/educator").then((module) => ({
    default: module.default,
  }))
)

const AboutPage = lazy(() =>
  import("../pages/AboutPage").then((module) => ({
    default: module.default,
  }))
);

const LoginPage = lazy(() =>
  import("../pages/LoginPage").then((module) => ({
    default: module.default,
  }))
);

const UserBenefitsPage = lazy(() =>
  import("../pages/UserBenefitsPage").then((module) => ({
    default: module.default,
  }))
);

const TermsOfServicePage = lazy(() =>
  import("../pages/TermsOfServicePage").then((module) => ({
    default: module.default,
  }))
);

const HelpDeskPage = lazy(() =>
  import("../pages/HelpDeskPage").then((module) => ({
    default: module.default,
  }))
);

const SignupPage = lazy(() =>
  import("../pages/SignupPage").then((module) => ({
    default: module.default,
  }))
);

const BlogsPage = lazy(() =>
  import("../pages/BlogsPage").then((module) => ({
    default: module.default,
  }))
);

const BlogPage = lazy(() =>
  import("../pages/BlogPage").then((module) => ({
    default: module.default,
  }))
);

const GuidesPage = lazy(() =>
  import("../pages/GuidesPage").then((module) => ({
    default: module.default,
  }))
);

const ShopPage = lazy(() =>
  import("../pages/ShopPage").then((module) => ({
    default: module.default,
  }))
);

const ProfessionalLRPage = lazy(() =>
  import("../pages/ProfessionalLRPage").then((module) => ({
    default: module.default,
  }))
);

const CheckoutSuccessPage = lazy(() =>
  import("../pages/CheckoutSuccessPage").then((module) => ({
    default: module.default,
  }))
);

const SchoolFaqPage = lazy(() =>
  import("../pages/FaqPage/SchoolFaqPage").then((module) => ({
    default: module.default,
  }))
);

const TeacherFaqPage = lazy(() =>
  import("../pages/FaqPage/TeacherFaqPage").then((module) => ({
    default: module.default,
  }))
);

const TeacherApplicationPage = lazy(() =>
  import("../pages/TeacherApplicationPage").then((module) => ({
    default: module.default,
  }))
)

const VerifyEmailPage = lazy(() =>
  import("../pages/Dashboard/VerifyEmailPage").then((module) => ({
    default: module.default,
  }))
)

const RefereeSurveyPage = lazy(() =>
  import("../pages/RefereeSurveyPage").then((module) => ({
    default: module.default,
  }))
)

const DocApi = lazy(() =>
  import("../pages/DocApi").then((module) => ({
    default: module.default,
  }))
)
const PayslipApi = lazy(() =>
  import("../pages/DocApi/PayslipURL").then((module) => ({
    default: module.default,
  }))
)

const AccountTypePage = lazy(() => 
  import("../pages/AccountTypePage").then((module) => ({
    default: module.default
  }))
)
const Test = lazy(() => 
  import("../pages/Test").then((module) => ({
    default: module.default,
  }))
)

export const ROOT_ROUTERS: RouteStore = {
  HomePage: <Route key='HomePage' path={`/`} element={<HomePage />} />,
  TeacherPage: (
    <Route
      key='TeacherPage'
      path={`/${TabNames.TEACHERS}`}
      element={
        <LandingPageLocationWrapper>
          <TeacherStatePageWrapper>
            <TeacherPage />
          </TeacherStatePageWrapper>
        </LandingPageLocationWrapper>
      }
    />
  ),
  VicTeacherPage: (
    <Route
      key='TeacherPage'
      path={`/${TabNames.TEACHERS}/vic`}
      element={
        <TeacherStatePageWrapper>
          <VicTeacherPage />
        </TeacherStatePageWrapper>
      }
    />
  ),
  NswTeacherPage: (
    <Route
      key='TeacherPage'
      path={`/${TabNames.TEACHERS}/nsw`}
      element={
        <TeacherStatePageWrapper>
          <NswTeacherPage />
        </TeacherStatePageWrapper>
      }
    />
  ),
  SchoolPage: (
    <Route
      key='SchoolPage'
      path={`/${TabNames.SCHOOLS}`}
      element={
        <LandingPageLocationWrapper>
          <SchoolStatePageWrapper>
            <SchoolPage />
          </SchoolStatePageWrapper>
        </LandingPageLocationWrapper>
      }
    />
  ),
  VicSchoolPage: (
    <Route
      key='SchoolPage'
      path={`/${TabNames.SCHOOLS}/vic`}
      element={
        <SchoolStatePageWrapper>
          <VicSchoolPage />
        </SchoolStatePageWrapper>
      }
    />
  ),
  NswSchoolPage: (
    <Route
      key='SchoolPage'
      path={`/${TabNames.SCHOOLS}/nsw`}
      element={
        <SchoolStatePageWrapper>
          <NswSchoolPage />
        </SchoolStatePageWrapper>
      }
    />
  ),
  AboutPage: (
    <Route
      key='AboutPage'
      path={`/${TabNames.ABOUT}`}
      element={<AboutPage />}
    />
  ),
  HelpDeskPage: (
    <Route
      key='HelpDeskPage'
      path={`/${TabNames.HELP_DESK}`}
      element={<HelpDeskPage />}
    />
  ),
  LoginPage: (
    <Route
      key='LoginPage'
      path={`/${TabNames.LOGIN}/*`}
      element={
        <AuthRoute customizedFallbackRoute={`/${TabNames.DASHBOARD}`}>
          <LoginPage />
        </AuthRoute>
      }
    />
  ),
  VerifyEmailPage: (
    <Route
      key="VerifyEmailPage"
      path={`/${TabNames.VERIFY_EMAIL}`}
      element={
      <VerifyWrapper>
        <VerifyEmailPage />
      </VerifyWrapper>}
    />
  ),
  UserBenefitsPage: (
    <Route
      key='UserBenefitsPage'
      path={`/${TabNames.SPARK_USER_BENEFITS}`}
      element={<UserBenefitsPage />}
    />
  ),
  // Old_Project: (
  //   <Route
  //     key='OldProject'
  //     path={`/${TabNames.OLD_PROJECT_URL}/*`}
  //     element={
  //       <ProctedRoute>
  //         <OldProject />
  //       </ProctedRoute>
  //     }
  //   />
  // ),
  TermsOfServicePage: (
    <Route
      key='TermsOfServicePage'
      path={`/${TabNames.TERMS_OF_SERVICE}`}
      element={<TermsOfServicePage />}
    />
  ),
  SignupPage: (
    <Route
      key='SignupPage'
      path={`/${TabNames.REGISTER}/*`}
      element={
        <AuthRoute customizedFallbackRoute={`/${TabNames.DASHBOARD}`}>
          <SignupPage />
        </AuthRoute>
      }
    />
  ),
  BlogsPage: (
    <Route
      key='SignupPage'
      path={`/${TabNames.BlogsHomePage}`}
      element={<BlogsPage />}
    />
  ),
  BlogPage: (
    <Route
      key='BlogsPage'
      path={`/${TabNames.BlogsHomePage}/:blogId`}
      element={<BlogPage />}
    />
  ),
  GuidesPage: (
    <Route
      key='GuidesPage'
      path={`/${TabNames.GUIDES}/:guideType`}
      element={<GuidesPage />}
    />
  ),
  ProfessionalLRPage: (
    <Route
      key='ProfessionalLRPage'
      path={`/${TabNames.ProfessionalLearningResourcePage}`}
      element={
        <LandingPageLocationWrapper>
          <ProfessionalLRPage />
        </LandingPageLocationWrapper>
      }
    />
  ),
  ShopPage: (
    <Route key='ShopPage' path={`/${TabNames.SHOP}/*`} element={<ShopPage />} />
  ),
  Dashboard: (
    <Route
      key='Dashboard'
      path={`/${TabNames.DASHBOARD}/*`}
      element={
        <DashboardRoute customizedFallbackRoute={`/${TabNames.LOGIN}`}>
          <Dashboard />
        </DashboardRoute>
      } />
  ),
  CheckoutSuccessPage: (
    <Route
      key='CheckoutSuccessPage'
      path={`/${TabNames.CHECKOUT_SUCCESS}`}
      element={<CheckoutSuccessPage />}
    />
  ),
  SchoolFaqPage: (
    <Route
      key='SchoolFaqPage'
      path={`/${TabNames.SCHOOL_FAQ}`}
      element={<SchoolFaqPage />}
    />
  ),
  TeacherFaqPage: (
    <Route
      key='TeacherFaqPage'
      path={`/${TabNames.TEACHER_FAQ}`}
      element={<TeacherFaqPage />}
    />
  ),
  TeacherApplicationPage: (
    <Route
      key='TeacherApplicationPage'
      path={`/${TabNames.TEACHER_APPLICATION}/:teacherId`}
      element={<TeacherApplicationPage />}
    />
  ),
  RefereeSurveyPage: (
    <Route
      key='RefereeSurveyPage'
      path={`/${TabNames.REFEREE_SURVEY}/:refereeId`}
      element={<RefereeSurveyPage />}
    />
  ),
  DocApi: (
    <Route
      key="DocApi"
      path={`/${TabNames.DOC_API}/:docSlug`}
      element={<DocApi/>}
      />
  ),
  PayslipApi: (
    <Route
      key="PayslipApi"
      path={`/${TabNames.PAYSLIP_API}/:uid/:fYear/:payslipId`}
      element={<PayslipApi/>}
      />
  ),
  ECCCentrePage: (
    <Route
      key="eccCentrePage"
      path={`/${TabNames.ECC_CENTRE}`}
      element={<ECCCentrePage/>}
    />
  ),
  ECCEducatorPage: (
    <Route
      key="eccEducatorPage"
      path={`/${TabNames.ECC_EDUCATOR}`}
      element={<ECCEducatorPage/>}
    />
  ),
  AccountTypePage: (
    <Route
      key="AccountTypePage"
      path={`/${TabNames.CHOOSE_ACC_TYPE}`}
      element={<AccountTypePage/>}
      />
  ),

  // Fallback
  Fallback: <Route key='Fallback' path={`/*`} element={<Navigate to={`/`} replace/>} />,
  // Test: (
  //   <Route
  //     key="Test"
  //     path={`/test`}
  //     element={<Test/>}
  //     />
  // )
};